module.exports = __webpack_public_path__ + "static/assets/62f7d06c93ee671948ba4970b9a53208.png";